<p-dialog
  [header]="headerKey | abpLocalization"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '36rem', maxWidth: '90vw' }"
  (onHide)="onHide()">
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="mb-3">
      <label for="declineReasonName" class="form-label text-uppercase fw-semibold small mb-1">
        {{ 'Settings::WorkEnvironment:DeclineReasons:Name' | abpLocalization }}
      </label>
      <input
        id="declineReasonName"
        [cxPendingLoader]="isValidating"
        type="text"
        pInputText
        class="form-control w-100"
        maxlength="100"
        formControlName="name"
        [placeholder]="'Settings::WorkEnvironment:DeclineReasons:NamePlaceholder' | abpLocalization" />
      <div
        *ngIf="form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched || submitted)"
        class="text-danger small mt-1">
        <span *ngIf="form.get('name')?.errors?.['required']">
          {{ 'Settings::WorkEnvironment:DeclineReasons:NameRequired' | abpLocalization }}
        </span>
        <span *ngIf="form.get('name')?.errors?.['maxlength']">
          {{ 'Settings::WorkEnvironment:DeclineReasons:NameMaxLength' | abpLocalization }}
        </span>
        <span *ngIf="form.get('name')?.errors?.['nameNotUnique']">
          {{ 'Settings::WorkEnvironment:DeclineReasons:NameAlreadyExists' | abpLocalization }}
        </span>
      </div>
    </div>

    <div class="mb-3">
      <label for="declineReasonQueues" class="form-label text-uppercase fw-semibold small mb-1">
        {{ 'Settings::WorkEnvironment:DeclineReasons:AssignToQueues' | abpLocalization }}
      </label>
      <p-multiselect
        inputId="declineReasonQueues"
        [(ngModel)]="selectedQueueIds"
        [ngModelOptions]="{ standalone: true }"
        [options]="availableQueues"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'Settings::WorkEnvironment:DeclineReasons:SelectQueuesPlaceholder' | abpLocalization"
        [filter]="true"
        appendTo="body"
        styleClass="w-100" />
    </div>
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'::Save' | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isBusy"
      [isSubmitting]="isBusy"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
